import React from 'react';
import { passwordRequirementTitle, passwordRequirementTitleMappings, InvalidRequirements } from './set-password-requirements';
import { IdentityPasswordComplexity } from 'appDtos';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { Translation, useTranslation } from '@chr/online-shared-ui-localizations';

export const SetPasswordChecklist = (props: any) => {
    const translate = useTranslation();
    const passwordRequirements:any = props.passwordRequirements as IdentityPasswordComplexity;
    const allowedSpecialCharacters = props.allowedSpecialCharacters;

    if (!passwordRequirements || !props.form) {
        return null;
    }

    let invalidRequirements:InvalidRequirements = [];

    if (props.form.syncErrors && 'password' in props.form.syncErrors) {
        invalidRequirements = props.form.syncErrors.password.invalidRequirements;
    }

    const approvedCharactersTooltip = (
        <Tooltip id="tooltip">
            <div className="text-left space-inner-top-sm space-inner-bottom-sm">
                <div>{translate('Alpha')}</div>
                <div className="h5 space-none">a-z, A-Z</div>
                <div className="space-outer-top-md">{translate('Numeric')}</div>
                <div className="h5 space-none">0-9</div>
                <div className="space-outer-top-md">{translate('Special Characters')}</div>
                <div className="h5 space-none">{allowedSpecialCharacters}</div>
            </div>
        </Tooltip>
    );

    const approvedCharactersOverlay = (
        <OverlayTrigger placement="bottom" overlay={approvedCharactersTooltip}>
            <button className="ns-icon ns-info btn-tooltip">
                <span className="sr-only">{translate('view approved characters')}</span>
            </button>
        </OverlayTrigger>
    );

    const getPasswordRequirements = Object.keys(passwordRequirements).map((titleKey) => {
        if (titleKey in passwordRequirementTitle && passwordRequirements[titleKey]) {
            let isValidStyleClass = 'is-valid';

            if (!props.form.values.password.length || invalidRequirements.includes(titleKey)) {
                isValidStyleClass = '';
            }

            if (titleKey === passwordRequirementTitle.validCharacters) {
                return (
                    <li className={`checkList-item ns-icon ns-success ${ isValidStyleClass }`} key={titleKey} aria-label={'checkList-item'}>
                        {translate(passwordRequirementTitleMappings[titleKey])}
                        {approvedCharactersOverlay}
                    </li>
                )
            } else {
                return (
                    <li className={`checkList-item ns-icon ns-success ${ isValidStyleClass }`} key={titleKey} aria-label={'checkList-item'}>
                        {translate(passwordRequirementTitleMappings[titleKey])}
                    </li>
                );
            }
        }
        return null;
    });

    return (
        <div className="checkList-wrapper">
            <h2 className="text-muted h5"><Translation resourceKey='Password Requirements:'/></h2>
            <ul className="checkList" aria-label={'checkList'}>{getPasswordRequirements}</ul>
        </div>
    );
}

